export const BAM_API_BASE_URL =
  process.env.NODE_ENV === 'production' ? window.config.BAM_API_BASE_URL : 'http://localhost:8080';

export const BAM_VERSION = process.env.NODE_ENV === 'production' ? window.config.BAM_VERSION : 'local';

export const GOOGLE_API_KEY = 'AIzaSyDYhuom59uzu9n25d4v7J0oSP9eDSdrX2c';
